module.exports = __webpack_public_path__ + "img/blue_124.477d171a.png";